
<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLine"></app-alert-line>

	<div class="row">
		<div class="col-12">
			<h2>Liste des dossiers</h2>
		</div>
	</div>
	
	<ng-template [ngIf]="hasEmptyList()">
		<div class="row">
			<div class="col-12">
				<h3>Vous n'avez aucun dossier en cours.</h3>
			</div>
		</div>
	</ng-template>

	<ng-template [ngIf]="!hasEmptyList()">

		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prev()" [disabled]="isFirstPage()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="reset()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="next()" [disabled]="isLastPage()" styleClass="p-button-text"></p-button>
		</div>
		<p-table
			[value]="datas"
			[columns]="columns"
			sortField="name"
			[paginator]="true"
			[rows]="rows"
			[showCurrentPageReport]="true"
			[(first)]="first"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} dossier(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-database-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columns>
				<tr>
					<th *ngFor="let col of columns" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.field"></p-sortIcon>
					</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-columns-filter">
					</th>
					<th *ngIf="userRole=='A'">
						<p-dropdown [options]="stateChoice" appendTo="body" (onChange)="dt.filter($event.value, 'state', 'equals')" styleClass="p-column-filter" placeholder="Choix de l'état" [showClear]="true">
							<ng-template style="z-index: 1024;" let-option pTemplate="item">
								<span [class]="'customer-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th *ngIf="userRole=='A'">
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'path', 'contains')" placeholder="Recherche par chemin" class="p-columns-filter">
					</th>
					<th>&nbsp;</th>
					<th>&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-folder let-folders="datas">
				<tr>
					<td>
						<a [routerLink]="['/folder-detail', folder['_id']]">{{folder["name"]}}</a>
					</td>
					<td *ngIf="userRole=='A'">
						<span *ngIf="folder['state'] == 'D'" class="ls-state-waiting">En attente</span>
						<span *ngIf="folder['state'] == 'R'" class="ls-state-running">En cours</span>
						<span *ngIf="folder['state'] == 'E'" class="ls-state-ended">Terminé</span>
						<span *ngIf="folder['state'] == 'X'" class="ls-state-inactive">Désactivé</span>
					</td>
					<td *ngIf="userRole=='A'">
						{{folder["path"]}}
					</td>
					<td>
						{{folder["nb_files"]}}
					</td>
					<td>
						{{folder["endDate"]}}
					</td>
				</tr>
			</ng-template>
		</p-table>
	</ng-template>
	<br>
</div>
